export const CRYPTO_REWARDS_ORDER_STATUS_PENDING = 'pending' as const

export const CRYPTO_REWARDS_ORDER_STATUS_FULFILLED = 'completed' as const
export const CRYPTO_REWARDS_ORDER_STATUS_CANCELLED = 'cancelled' as const

export const CRYPTO_REWARDS_ORDER_TYPE_BUY = 'buy' as const

export const CRYPTO_REWARDS_ORDER_TYPE_SELL = 'sell' as const
